import React, { useEffect, useMemo, useRef } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { downloadAgendaPdf } from '../component/um/agenda/utils/exportAgendaPdf'
import { useSettingAgendas } from '../services/um/useSettingAgendas'

const ExportAgendaAutoDownloadPage: React.FC = () => {
    const { id } = useParams<{ id: string }>()
    const location = useLocation()
    const { getExportAgendaById } = useSettingAgendas()

    const token = useMemo(() => new URLSearchParams(location.search).get('token') ?? '', [location.search])
    const irb = useMemo(() => new URLSearchParams(location.search).get('irb') ?? '', [location.search])

    const hasRun = useRef(false)

    useEffect(() => {
        if (!id || !token || hasRun.current) return
        hasRun.current = true

        let alive = true
        const fetchProject = async () => {
            try {
                const res = await getExportAgendaById(irb, id, token)
                if (!alive || !res) return

                await downloadAgendaPdf(res)

                setTimeout(() => {
                    window.close?.()
                }, 400)
            } catch (e) {
                console.error('export agenda failed:', e)
            }
        }

        fetchProject()

        return () => {
            alive = false
        }
    }, [id, token, location.search])

    return null
}

export default ExportAgendaAutoDownloadPage
